import React from "react";
import { compose } from "redux";
import BaseCommissionsSubsidiesComponent from "./BaseCommissionsSubsidiesComponent";

const visibleColumns = ["Name", "CalculationName", "Percent", "Amount", "Currency", "FreeTxt"];

const CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7 = props => {
  return <BaseCommissionsSubsidiesComponent visibleColumns={visibleColumns} {...props} />;
};

CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7.defaultProps = {
  isSubsidy: false
};

CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7.propTypes = {};

export default compose()(CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7);
